import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=10c998c7&scoped=true&"
import script from "./InputTextarea.vue?vue&type=script&lang=js&"
export * from "./InputTextarea.vue?vue&type=script&lang=js&"
import style0 from "./InputTextarea.vue?vue&type=style&index=0&id=10c998c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c998c7",
  null
  
)

export default component.exports